import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import IleDeFranceMap from "@/components/IleDeFranceMap";
import CTASection from "@/components/CTASection";
import LongForm from "@/components/LongForm";
import { SEO_CONTENT } from "@/data/seoContent";
import { DEPARTMENTS } from "@/data/site";

export default function Zone() {
  return (
    <>
      <Seo
        title="Zone d'Intervention FuiteX en Île-de-France"
        description="FuiteX intervient dans toute l'Île-de-France : Paris, Seine-et-Marne, Yvelines, Essonne, Hauts-de-Seine, Seine-Saint-Denis, Val-de-Marne, Val-d'Oise."
        canonical="/zone-intervention"
      />
      <PageHero
        overline="Zone d'intervention"
        titleLines={["Notre zone d'intervention", "en Île-de-France"]}
        subtitle="Une couverture complète sur les 8 départements de la région. Sélectionnez le vôtre pour découvrir notre intervention locale."
        breadcrumb={[{ label: "Zone d'intervention" }]}
      />

      <section className="bg-ink py-16 grain relative overflow-hidden">
        <div className="container-x relative z-10 max-w-3xl mx-auto">
          <IleDeFranceMap />
        </div>
      </section>

      <section className="bg-white py-24">
        <div className="container-x">
          <Reveal>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-ink">Les 8 départements couverts</h2>
            <p className="mt-4 text-lg text-ink/70 max-w-2xl">
              Intervention rapide où que vous soyez en Île-de-France, avec des techniciens et un matériel
              professionnel adaptés à chaque secteur.
            </p>
          </Reveal>
          <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {DEPARTMENTS.map((d, i) => (
              <Reveal key={d.slug} delay={i * 0.05}>
                <Link
                  to={`/zone-intervention/${d.slug}`}
                  data-testid={`zone-card-${d.code}`}
                  className="group block rounded-3xl border border-ink/10 p-7 hover:bg-ink hover:border-ink transition-colors h-full"
                >
                  <div className="flex items-center justify-between">
                    <span className="text-4xl font-black text-aqua">{d.code}</span>
                    <MapPin size={20} className="text-ink/30 group-hover:text-aqua transition-colors" />
                  </div>
                  <h3 className="mt-4 text-lg font-bold text-ink group-hover:text-white transition-colors">{d.name}</h3>
                  <p className="mt-1 text-xs text-ink/50 group-hover:text-white/60 transition-colors line-clamp-1">
                    {d.cities.slice(0, 2).join(", ")}…
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-aqua opacity-0 group-hover:opacity-100 transition-opacity">
                    Découvrir <ArrowRight size={16} />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-mist py-24">
        <div className="container-x">
          <LongForm data={SEO_CONTENT.zone} />
        </div>
      </section>

      <CTASection />
    </>
  );
}
